import { Component, OnInit, signal, Signal, WritableSignal } from '@angular/core';
import { ConfigInput } from '../../interfaces/interfaces';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../services/security.service';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../../shared/input/input.component';
import { LoaderService } from '../../services/loader.service';
import { HelpService } from '../../services/help.service';

@Component({
  selector: 'app-balance',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputComponent
],
  templateUrl: './balance.component.html',
  styleUrl: './balance.component.css'
})
export class BalanceComponent implements OnInit{
  form: FormGroup;
  incomeExtraActivity: number = 0;

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: 'Egresos', subLabel: '', formName: 'outcome', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor ingresa un valor válido'},
    { label: 'Activos', subLabel: '', formName: 'assets', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor ingresa un valor válido'},
    { label: 'Pasivos', subLabel: '', formName: 'liabilities', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [ Validators.required], textError: 'Por favor ingresa un valor válido'},
  ])


  constructor(
    private _router: Router,
    private _title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _helpService: HelpService
  ){
    this._title.setTitle('Onboarding Digital | Balance');
    this.form = new FormGroup({
      outcome: new FormControl(null, [Validators.required]),
      assets: new FormControl(null, [Validators.required]),
      liabilities: new FormControl(null, [Validators.required]),
    });


  }
  ngOnInit(): void {
    this.getData();
    this._loaderService.hide();
    this._helpService.show();
  }

  getData(){
    this._securityService.getBalance().subscribe({
        next: (response: any) => {
          this.form.patchValue(response);

          this.dataInputs.update((inputs:any) =>
            inputs.map((input:any) => ({
              ...input,
              defaultValue: response[input.formName] ?? input.defaultValue
            }))
          );
          this.incomeExtraActivity = response.incomeExtraActivity ? response.incomeExtraActivity : 0;
        },
        error: (error:any) => {
          console.error("ERROR: ",error)
        }
      });
  }

  handleValue(event: {formName:string, value:string | number}) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  onSubmit(){
    if(this.form.valid) {
      this._securityService.setBalance(this.form.value).subscribe({
        next: (response: any) => {
          this._router.navigate(['/app/foreign']);
        },
        error: (error:any) => {
          console.error("ERROR: ",error)
        }
    });
    }
  }

  getGains(): string {
    const outcome = parseFloat(this.form.get('outcome')?.value);
    const assets = parseFloat(this.form.get('assets')?.value);
    const liabilities = parseFloat(this.form.get('liabilities')?.value);
  
    if (isNaN(this.incomeExtraActivity) || isNaN(outcome) || isNaN(assets) || isNaN(liabilities)) {
      throw new Error('Todos los campos deben ser números válidos.');
    }

    const gains = (this.incomeExtraActivity - outcome) + (assets - liabilities);
    return gains.toString();
  }

}
